import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentMatchedWebsiteState } from '../types';

/**
 * 当前匹配网站排行榜模型
 * @description 存储当前匹配网站排行榜状态
 */
export interface CurrentMatchedWebsiteModel extends Model<CurrentMatchedWebsiteState>, Disposable {

}

export const CurrentMatchedWebsiteModel = Symbol.for('CurrentMatchedWebsiteModel');
